import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    form_name: null,
    form_type: null,
    description: null,
    // Autres propriétés du formulaire si nécessaire
};

export const selectedForm = createSlice({
    name: "form",
    initialState,
    reducers: {
        setSelectedForm: (state, {payload}) => payload,
        setFormType: (state, {payload}) => {
            state.form_type = payload;
        },
        clearSelectedForm: (state) => {
            return initialState;
        }
    }
})

export const { setSelectedForm, setFormType, clearSelectedForm } = selectedForm.actions

export default selectedForm.reducer